
                            module.exports = function( bundle ) {
                                var loader = require( "./loader-52d6d0206c289db0a73ab847e8efeaf1.js" );
                                return loader( bundle );
                            };
                        